// react
import { useContext } from 'react';

// context
import { ContextEntityCashBenefits } from '../Entity.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableCashBenefits } from '../../../tables/cards/TableCashBenefits/TableCashBenefits';

export const CashBenefits = () => {
	// context
	const { isLoadingCashBenefits, paginationCashBenefits, cashBenefits, refetchCashBenefits } =
		useContext(ContextEntityCashBenefits);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableCashBenefits
						frame="ENTITY"
						isLoading={isLoadingCashBenefits}
						pagination={paginationCashBenefits}
						refetchTransactions={refetchCashBenefits}
						transactions={cashBenefits}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
